// extracted by mini-css-extract-plugin
export default {"body":"WhyWe_body__O+rSb","body__wrap":"WhyWe_body__wrap__pfL0r","mapDiv__wrap":"WhyWe_mapDiv__wrap__HbgPJ"};